import { IMetaFormat, TIFormatPrefix } from '../../../../../../store/admin/roundFormats/store';
import { IMetaFormats } from '../../AssignResults/Context/AssignResults.context';

export const getRoundFormatsList = (adminRoundFormats: IMetaFormat[]) => {
  return !!adminRoundFormats.length
    ? adminRoundFormats.reduce(
        (formats: IMetaFormats, roundFormat: IMetaFormat) => ({
          ...formats,
          [roundFormat.id]: {
            ...roundFormat,
            format: {
              ...roundFormat.format,
              prefix: roundFormat.format.prefix.replace('_', '') as TIFormatPrefix
            }
          }
        }),
        {}
      )
    : {};
};
